import React from "react";

const Overview = ({
  width = 20,
  height = 12,
  stroke = "#2F6AF5",
  strokeWidth = 1.65,
  strokeLinecap = "round",
  strokeLinejoin = "round",
}) => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="48"
        height="48"
        rx="8"
        transform="matrix(1 0 0 -1 0 48)"
        fill="#45CA08"
        fill-opacity="0.1"
      />
      <path
        d="M27.9144 32.8087V30.8512H34.3604L25.9569 22.4477L21.7551 26.6494C21.5716 26.8329 21.3227 26.936 21.0631 26.936C20.8036 26.936 20.5547 26.8329 20.3711 26.6494L10.2969 16.5752L11.6808 15.1912L21.0631 24.5735L25.2649 20.3717C25.4484 20.1883 25.6973 20.0852 25.9569 20.0852C26.2164 20.0852 26.4653 20.1883 26.6489 20.3717L35.7444 29.4673V23.0212H37.7019V32.8087H27.9144Z"
        fill="#45CA08"
      />
    </svg>
  );
};

export default Overview;
